import { useEffect } from 'react'

import { useUpdateEmptyStateViewed } from 'features/empty_state'
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events'

import { CenteredEmptyState } from './centered'
import { ANALYTICS_CTA_SHOWN_PROPS_MAP, EMPTY_STATE_TYPES } from './constants'
import { LeftRightEmptyStateContainer } from './left_right'
import { PreviewEmptyState } from './preview'
import { TemplatesEmptyState } from './templates'

const withDefaultAnalytics = (Component) => (props) => {
  const { contentKey } = props
  const [emptyStateViewed, update, isUninitialized] = useUpdateEmptyStateViewed({ contentKey })
  const track = useTrack()

  useEffect(() => {
    if (!isUninitialized || emptyStateViewed) return

    const properties = ANALYTICS_CTA_SHOWN_PROPS_MAP[contentKey]
    if (!properties) return

    track({
      name: TRACKING_EVENT_NAMES.CTA_SHOWN,
      entities: ['attribution', 'organization', 'user'],
      properties
    })

    update()
  }, [contentKey, emptyStateViewed, update, isUninitialized, track])

  return <Component {...props} />
}

const BaseEmptyState = ({ type, children, ...props }) => {
  if (type === EMPTY_STATE_TYPES.centered) {
    return <CenteredEmptyState {...props} />
  }

  if (type === EMPTY_STATE_TYPES.leftRight) {
    return <LeftRightEmptyStateContainer {...props} />
  }

  if (type === EMPTY_STATE_TYPES.preview) {
    return <PreviewEmptyState {...props}>{children}</PreviewEmptyState>
  }

  if (type === EMPTY_STATE_TYPES.templates) {
    return <TemplatesEmptyState {...props}>{children}</TemplatesEmptyState>
  }

  return <CenteredEmptyState {...props} />
}

export const EmptyState = ({ withAnalytics = withDefaultAnalytics, ...props }) => {
  const EnhancedEmptyState = withAnalytics(BaseEmptyState)
  return <EnhancedEmptyState {...props} />
}
